import React from 'react';
import PropTypes from 'prop-types';
import ViPropTypes from '../propTypes';
import MediaPlayer from './MediaPlayer';
import Timeline from '../PlayerDashboard/Timeline';
import PlayerDashboard from '../PlayerDashboard';

export default class FullVideoPlayer extends React.Component {

  static propTypes = {
    mobile: PropTypes.bool,
    mediaLoaded: PropTypes.bool,
    showDashboard: PropTypes.bool,
    showCameraIcons: PropTypes.bool,
    media: ViPropTypes.Media,
    clip: ViPropTypes.Clip,
    currentCamera: PropTypes.string,
    flowplayerKey: PropTypes.string.isRequired,
    customerSettings: ViPropTypes.CustomerSettings,
    onPlayerTimeChanged: PropTypes.func,
    onCameraChange: PropTypes.func,
    userSettings: ViPropTypes.UserSettings
  };

  static defaultProps = {
    mobile: false,
    mediaLoaded: true,
    showDashboard: true,
    showCameraIcons: true,
    onPlayerTimeChanged: () => {},
    onCameraChange: () => {}
  }

  state = {
    playerCurrentSecond: 0
  }

  constructor(props) {
    super(props);
  }

  handlePlayerTimeChanged = playerCurrentSecond => {
    this.setState({
      playerCurrentSecond
    });

    this.props.onPlayerTimeChanged(playerCurrentSecond);
  }

  renderDashboard() {
    if (!this.props.showDashboard) {
      return null;
    }

    const {
      mobile,
      mediaLoaded,
      media,
      customerSettings,
      userSettings
    } = this.props;

    const {playerCurrentSecond} = this.state;

    return (
      <React.Fragment>
        <Timeline
          mediaLoaded={mediaLoaded}
          media={media}
        />
        <PlayerDashboard
          mobile={mobile}
          mediaLoaded={mediaLoaded}
          currentSecond={playerCurrentSecond}
          media={media}
          customerSettings={customerSettings}
          userSettings={userSettings}
        />
      </React.Fragment>
    );
  }

  render() {
    const {
      mediaLoaded,
      showCameraIcons,
      media,
      clip,
      currentCamera,
      flowplayerKey,
      onCameraChange,
      mobile,
      customerSettings,
      userSettings
    } = this.props;

    return (
      <React.Fragment>
        <MediaPlayer
          mediaLoaded={mediaLoaded}
          showCameraIcons={showCameraIcons}
          media={media}
          clip={clip}
          currentCamera={currentCamera}
          flowplayerKey={flowplayerKey}
          onCameraChange={onCameraChange}
          onPlayerTimeChanged={this.handlePlayerTimeChanged}
          mobile={mobile}
          customerSettings={customerSettings}
          userSettings={userSettings}
        />

        {this.renderDashboard()}
      </React.Fragment>
    );
  }
}
